import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from 'apollo-client';
import { Http, Response } from '@angular/http';
import {
  GetUserQuery,
  SearchUsers,
  checkUserQuery,
  loadAllRequests,
  deleteRequest,
  setFamilyLabels,
  getNonInviteAcceptedUsers,
  deleteUser,
  transferRole,
  assignUserType,
  resendActivation,
  resetUserPassword,
  getSubLabels
} from '../../queries/users.model';
import { loadApplicationFeatures, loadAllRestrictedApplications } from '../../queries/general.model';
const url = (location.hostname.indexOf('musicinsights.com') >= 0) ? process.env.MI_API_HOST : process.env.API_HOST;;

@Injectable()
export class UserService {
  public showAddExternal;
  public showInviteRequest;
  public externalEdit;
  public requestCount;
  public showNewUser: boolean;
  public isValid: boolean;
  public externalUser: Object;
  public newUserObject: object;
  public featureList: any;
  public originalDefaultLabels:any;
  public defaultLabels: any;
  public countryList: any;
  public isCopy: boolean;
  public isNewReqCopy: boolean;
  public duplicateUser:Object;
  public externalVip = [];
  public userRestrict: boolean;
  public showAccountCreated: boolean;

  // Activation variables
  public userEmail: string;
  public userToken: string;
  public universalArtists: boolean;
  public showActivationLinkExpired: boolean;
  public showCreatePassword: boolean;
  public showSecurityQuestion: boolean;
  public userPassword: string;
  public confirmPassword: string;
  public enablePasswordReset: boolean;
  public triggerPts: any;
  public client: string;
  public prevScreen: boolean;
  public nextScreen: boolean;
  public redirectLink: string;
  public securityQuestionForPR: string;
  public blur: boolean;
  public inputFocus: boolean;
  public inputFocusConfirm: boolean;
  public currentlyViewingMobile: number;

  constructor(private apollo:Apollo,
              private http: Http){
    this.blur = false;
    this.showInviteRequest = false;
    this.showAddExternal = false;
    this.showNewUser = false;
    this.userRestrict = false;
    this.externalEdit = false;
    this.externalVip = ['Disney', 'Concord', 'ABC'];

    // Activation default variables
    this.userEmail = '';
    this.userToken = '';
    this.universalArtists = false;
    this.showActivationLinkExpired = false;
    this.showAccountCreated = false;
    this.showCreatePassword = false;
    this.showSecurityQuestion = false;
    this.userPassword = '';
    this.confirmPassword = '';
    this.enablePasswordReset = false;
    this.securityQuestionForPR = '';
    this.triggerPts = [];
    this.prevScreen = false;
    this.nextScreen = false;
    this.redirectLink = '';
    this.inputFocus = false;
    this.inputFocusConfirm = false;
    this.currentlyViewingMobile = 0;
  };
  // get all users with the ability to search
  getUsers(term: string,
           internal: boolean,
           types: [string],
           active: boolean,
           paging: Object,
           createdUserId: string,
          labels: [string]) {
    // let paging = {skip: 0, limit: 50};
    let params = {
      searchText: term,
      internal: internal,
      paging: paging,
      createdUserId: createdUserId,
      labels: labels
    };

    if (types !== null) {
      params['types'] = types;
    } else if(active !== null) {
      params['active'] = active;
    }

    return this.apollo.query({
      query: SearchUsers,
      fetchPolicy: 'network-only',
      variables: params
    })
    .map(({data}) => data)
    .catch((error) => {
      // console.log('err:', error);
      throw(error);
    });
  }

  // load all new user requests
  loadAllusers(): Observable<ApolloQueryResult<Object>>{
    let paging = {skip: 0, limit: 5};
    return this.apollo.query({
      query: loadAllRequests,
      fetchPolicy: 'network-only',
      variables: paging
    });
  }

  // mutation to send approved revenue
  // approveViewRevenue(id) {
  //   // console.log('id in approve revenue: ', id);
  //   this.apollo.mutate({
  //     mutation: ApproveRevenueViewer,
  //     variables:{
  //       ID:id
  //     }
  //   }).map(data);
  // }

  // get a singular user for edit page
  getUser(id: string): Observable<any> {
    return this.apollo.query({
        query: GetUserQuery,
        variables:{
        ID:id
      }
    })
    .map(({data}) => data);
  }

  checkNewUser(email: string) {
   return this.apollo.query({
     query: checkUserQuery,
     variables: {
       email: email
     }
   })
     .map(({data}) => data)
     .catch((error) => {
      throw error;
     });
  }

  setExternalUser(user) {
    this.externalUser = user;
  }

  getExternalUser() {
    return this.externalUser;
  }

  deleteRequest(user) {
    return this.apollo.mutate({
      mutation: deleteRequest,
      variables: {
        id: user._id
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  getCountries() {
    let dataUrl = url+'/api/countries';
    return this.http.get(dataUrl)
      .map((res: Response) =>
        // console.log(res.json()),
        this.countryList = res.json()
      )
      .catch((error) => {
        throw error;
      });
  }

  getDefaultLabels() {
    let dataUrl = url+'/api/labels';
    return this.http.get(dataUrl)
      .map((res: Response) =>
        this.originalDefaultLabels = res.json()
      )
      .catch((error) => {
        throw error;
      });
  }



  setFamilyLabels(user) {
    return this.apollo.mutate({
      mutation: setFamilyLabels,
      variables: {
        id: user.id,
        applicationName: user.applicationName,
        familyLabels: user.familyLabels
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  getOktaNotActiveUsers() {
    return this.apollo.query({
      query: getNonInviteAcceptedUsers,
      fetchPolicy: 'network-only'
    }).map(({data}) => data)
      .catch((error) => {
        console.log('err:', error);
        throw(error);
      });
  }

  resetUserPasswordOkta(email) {
    return this.apollo.mutate({
      mutation: resetUserPassword,
      variables: {
        email: email
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  resendActivation(email) {
    return this.apollo.mutate({
      mutation: resendActivation,
      variables: {
        email: email
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  deleteUser(user) {
    return this.apollo.mutate({
      mutation: deleteUser,
      variables: {
        email: user.email,
        id: user.id
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  transferRole(user) {
    return this.apollo.mutate({
      mutation: transferRole,
      variables: {
        fromUserId: user.fromUserID,
        toUserId: user.toUserID,
        role: user.role,
        applicationName: user.applicationName
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  assignUserType(user) {
    return this.apollo.mutate({
      mutation: assignUserType,
      variables: {
        assignerId: user.assignerId,
        assigneeId: user.assigneeId,
        app: user.app,
        type: user.type
      }
    }).map(({data}) => data)
      .catch((error) => {
        throw error;
      });
  }

  loadApplicationFeatures() {
    return this.apollo.query({
      query: loadApplicationFeatures,
      fetchPolicy: 'network-only'
    }).map(({data}) => data)
      .catch((error) => {
        console.log('err:', error);
        throw(error);
      });
  }

  loadAllRestrictedApplications() {
    return this.apollo.query({
      query: loadAllRestrictedApplications,
      fetchPolicy: 'network-only'
    }).map(({data}) => data)
    .catch((error) => {
      console.log('err:', error);
      throw(error);
    });
}

getSubLabels(labelName: string) {
  return this.apollo.query({
    query: getSubLabels,
    variables: {
      labelName
    }
  })
    .map(({data}) => data)
    .catch((error) => {
     throw error;
    });
 }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./src/app/shared/services/user.service.ts